/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Suggestions_TitleInputs */

const en_us2_search_suggestions_title = /** @type {(inputs: Search_Suggestions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try searching`)
};

const pt_br2_search_suggestions_title = /** @type {(inputs: Search_Suggestions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experimente buscar`)
};

const es_419_search_suggestions_title = /** @type {(inputs: Search_Suggestions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prueba a buscar`)
};

const pt_pt2_search_suggestions_title = /** @type {(inputs: Search_Suggestions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experimenta pesquisar`)
};

const fr_fr2_search_suggestions_title = /** @type {(inputs: Search_Suggestions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essaie de chercher`)
};

const de_de2_search_suggestions_title = /** @type {(inputs: Search_Suggestions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Probier mal`)
};

const it_it2_search_suggestions_title = /** @type {(inputs: Search_Suggestions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prova a cercare`)
};

/**
* | output |
* | --- |
* | "Try searching" |
*
* @param {Search_Suggestions_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_suggestions_title = /** @type {((inputs?: Search_Suggestions_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Suggestions_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_suggestions_title(inputs)
	if (locale === "es-419") return es_419_search_suggestions_title(inputs)
	if (locale === "pt-PT") return pt_pt2_search_suggestions_title(inputs)
	if (locale === "fr-FR") return fr_fr2_search_suggestions_title(inputs)
	if (locale === "de-DE") return de_de2_search_suggestions_title(inputs)
	if (locale === "it-IT") return it_it2_search_suggestions_title(inputs)
	return en_us2_search_suggestions_title(inputs)
});
export { search_suggestions_title as "search.suggestions_title" }